import {convertCoordinates} from '@/api/util-coordinates';

class PoiApiResponseModel {
  // #region Props

  // #endregion
  constructor({
    name,
    province,
    region,
    town,
    category,
    description,
    provinceId,
    cx,
    cy,
    visible,
    id,
  }) {
    return {
      id,
      name,
      provinceId,
      province,
      region,
      town,
      category,
      description,
      coordinates: convertCoordinates(cx, cy),
      visible: !!visible ? true : false,
    };
  }
}

export default PoiApiResponseModel;
